import { Auth } from 'aws-amplify';
import axios from 'axios';
import {
  CRUISE_SETTING_URL,
  CRUISE_API_KEY,
  GET_MWID_AUTHZDB,
  AUTHZDB_BASEURL,
  getInvoiceApiUrl,
  PPA_API_BASEURL,
  LAPLACE_PASSPORT_API_METHOD,
} from '../../configures/val.js';
import findLocalStorage from './findLocalStorage.js';

async function authCheck() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const attrRet = await Auth.userAttributes(user);
    const ret = {
      result: 'OK',
      data: attrRet,
    };
    return ret;
  } catch (error) {
    console.log('error == authCheck');
    await Auth.signOut();
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}

export async function getCruiseSetting(mierukaId) {
  const config = {
    headers: {
      'X-Api-Key': CRUISE_API_KEY,
    },
  };
  try {
    const urlStr = CRUISE_SETTING_URL + mierukaId;
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result,
    };
    return ret;
  } catch (error) {
    console.log('error == getCruiseSetting');
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}

export async function putCruiseSetting(mierukaId, param) {
  const idtoken = findLocalStorage('idToken');
  const accessToken = findLocalStorage('accessToken');
  const config = {
    headers: {
      'x-api-key': CRUISE_API_KEY,
      idtoken: idtoken,
      accesstoken: accessToken,
    },
  };
  try {
    const urlStr = CRUISE_SETTING_URL + mierukaId;
    let result = await axios.put(urlStr, param, config);
    const ret = {
      result: 'OK',
      data: result,
    };
    return ret;
  } catch (error) {
    console.log('error == putCruiseSetting');
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}

export async function deleteCruiseSetting(mierukaId) {
  const urlStr = CRUISE_SETTING_URL + mierukaId;
  const idtoken = findLocalStorage('idToken');
  const accessToken = findLocalStorage('accessToken');
  const config = {
    headers: {
      'x-api-key': CRUISE_API_KEY,
      accesstoken: accessToken,
      idtoken: idtoken,
    },
  };
  try {
    let result = await axios({
      method: 'delete',
      url: urlStr,
      headers: config.headers,
    });
    const ret = {
      result: 'OK',
      data: result,
    };
    return ret;
  } catch (error) {
    console.log('error == deleteCruiseSetting');
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
export async function getMierukaIds() {
  const urlStr = GET_MWID_AUTHZDB + 'mierukawebids';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result,
    };
    return ret;
  } catch (error) {
    console.log('error == getMierukaIds');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
export async function getCanIAccessToFromAuthzdb(mwid) {
  const urlStr = GET_MWID_AUTHZDB + 'cani/editmieruka/' + mwid;
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result,
    };
    return ret;
  } catch (error) {
    console.log('error == getCanIAccessToFromAuthzdb');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
export async function getCanIAccessAsSuperFromAuthzdb() {
  const urlStr = GET_MWID_AUTHZDB + 'amisuper';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result,
    };
    return ret;
  } catch (error) {
    console.log('error == getCanIAccessAsSuperFromAuthzdb');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
export async function getInvoiceList() {
  const urlStr = getInvoiceApiUrl('billList');
  const token = findLocalStorage('idToken');
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result.data,
    };
    return ret;
  } catch (error) {
    console.log('error == getInvoiceApiUrl');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
export async function getCanIseeInvoiceList() {
  const urlStr = GET_MWID_AUTHZDB + 'cani/see/invoice_list';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
  try {
    let result = await axios.get(urlStr, config);
    const ret = {
      result: 'OK',
      data: result.data,
    };
    return ret;
  } catch (error) {
    console.log('error == getCanIseeInvoicelist');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
export async function getInvoiceReport(fileName) {
  let urlStr = getInvoiceApiUrl('report');
  urlStr += '/' + fileName;
  const token = findLocalStorage('idToken');
  const config = {
    headers: {
      'Content-Type': 'application/pdf',
      Authorization: 'Bearer ' + token,
    },
    responseType: 'blob',
  };
  try {
    let result = await axios.get(urlStr, config);
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement('a');
    link.href = url;
    const downloadFilename = fileName + '.pdf';
    link.setAttribute('download', downloadFilename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return { result: 'OK' };
  } catch (error) {
    console.log('error == getInvoiceReport');
    console.log(error);
    const ret = {
      result: 'NG',
      data: error,
    };
    return ret;
  }
}
// AuthZ ===
// PPA 発電所一覧の products を得るための 事業者ID の列挙を返す
export function getPpaSid() {
  const urlParam = 'belong/ppasupplier';
  return getAuthz(urlParam);
}
function getAuthz(to, params) {
  const url = AUTHZDB_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: 'Bearer ' + authHeader,
  };
  return getApi(url, headers, params);
}

// PPA ===
export function getPpaService(sId) {
  const urlParam = 'service/' + sId;
  return getPpaApi(urlParam);
}
export function getPpaProduct(params) {
  return getPpaApi('products', params);
}
function getPpaApi(to, params) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader,
  };
  return getApi(url, headers, params);
}

export function postPpaDisplayPattern(params) {
  const url = 'displaypattern/';
  return postPpaApi(url, params);
}
function postPpaApi(to, params) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader,
  };
  return postApi(url, headers, params);
}

export function putPpaDisplayPatternId(pId, params) {
  const url = 'product/' + pId + '/displaypatternid';
  return putPpaApi(url, params);
}
export function putPpaDisplayPattern(pId, params) {
  const url = 'displaypattern/' + pId;
  return putPpaApi(url, params);
}
function putPpaApi(to, params) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader,
  };
  return putApi(url, headers, params);
}
export function deletePpaDisplayPattern(pId, sId) {
  const url = `displaypattern/${pId}?supplierId=${sId}`;
  return deletePpaApi(url);
}
function deletePpaApi(to, param) {
  const url = PPA_API_BASEURL + to;
  const authHeader = findLocalStorage('idToken');
  const headers = {
    Authorization: authHeader,
  };
  return deleteApi(url, headers);
}

// PPMS ===
// PPMS 発電所管理システムの利用権限を取得する
export async function getCanISeePpms() {
  const urlStr = AUTHZDB_BASEURL + 'cani/see/ppms';
  const token = findLocalStorage('accessToken');
  const config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
  try {
    let result = await axios.get(urlStr, config);
    if (result.data.result !== undefined) {
      return result.data.result;
    }
    return false;
  } catch (error) {
    console.log('error == getCanISeePpms');
    console.log(error);
    return false;
  }
}

// Common ===
async function getApi(urlStr, header, params) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  if (params) {
    config.params = params;
  }
  try {
    const res = await axios.get(urlStr, config);
    return {
      result: 'OK',
      data: res.data,
    };
  } catch (err) {
    console.log(urlStr + 'GET API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs,
    };
  }
}
async function postApi(urlStr, header, params) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  try {
    const res = await axios.post(urlStr, params, config);
    return {
      result: 'OK',
      data: res.data,
    };
  } catch (err) {
    console.log(urlStr + 'POST API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs,
    };
  }
}
async function putApi(urlStr, header, params) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  try {
    const res = await axios.put(urlStr, params, config);
    return {
      result: 'OK',
      data: res.data,
    };
  } catch (err) {
    console.log(urlStr + 'PUT API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs,
    };
  }
}
async function deleteApi(urlStr, header) {
  const config = {};
  if (header) {
    config.headers = header;
  }
  try {
    const res = await axios.delete(urlStr, config);
    return {
      result: 'OK',
      data: res.data,
    };
  } catch (err) {
    console.log(urlStr + 'DELETE API err');
    const errs = getErrors(err);
    return {
      result: 'NG',
      data: errs,
    };
  }
}
function getErrors(catchErr) {
  const resObj = {};
  if (catchErr.response) {
    resObj.data = catchErr.response.data;
    resObj.status = catchErr.response.status;
    resObj.headers = catchErr.response.headers;
  }
  if (catchErr.message) {
    resObj.message = catchErr.message;
  }
  return resObj;
}

/**
 * 現在認証済ユーザの sub を取得する。
 * ユーザが認証済でない場合やその他のエラーで sub が取得できなかった場合は null を返す。
 * @returns {string|null}
 */
export const fetchUserSub = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user.attributes.sub;
  } catch (_) {
    return null;
  }
};

/**
 * ラプラスパスポートの API を実行する
 * @param {string} endpoint - ラプラスパスポートの共通エンドポイントに続くエンドポイント
 * @param {RequestInit.method} method - リクエストメソッド。デフォルトは GET。
 * @param {*} data - リクエストボディ
 * @returns
 */
const callLaplacePassportApi = async (
  endpoint,
  method = LAPLACE_PASSPORT_API_METHOD.GET,
  data = null,
  responseType = 'json'
) => {
  if (!(method in LAPLACE_PASSPORT_API_METHOD))
    throw new Error(`The method '${method}' is invalid.`);
  /** @type {RequestInit} */
  const init = {
    method: method,
    headers: {
      Authorization: findLocalStorage('idToken'),
    },
  };
  if (data) {
    init.headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify(data);
  }
  const res = await fetch(
    process.env.REACT_APP_LAPLACE_PASSPORT_API_DEFAULT_ENDPOINT + endpoint,
    init
  );

  let resData = null;
  try {
    if (res.ok) {
      switch (responseType) {
        case 'json':
          resData = await res.json();
          break;
        case 'blob':
          resData = await res.blob();
          break;
        default:
          throw new Error('invalid response type');
      }
    } else {
      resData = await res.json();
    }
  } catch (e) {
    console.error(e);
  }

  return {
    ok: res.ok,
    status: res.status,
    data: resData,
  };
};

/**
 * ユーザを削除する
 * @param {string} sub - Cognito の sub
 */
export const fetchUserAccounts = async (sub) => {
  return await callLaplacePassportApi(`/users/${sub}/accounts`);
};

/**
 * アカウントを取得する
 * @param {number} accountId - アカウント ID
 */
export const fetchAccount = async (accountId) => {
  return await callLaplacePassportApi(`/accounts/${accountId}`);
};

/**
 * アカウントの表示名を更新する
 * @param {number} accountId - アカウント ID
 * @param {string} displayName - 表示名
 */
export const updateAccountDisplayName = async (accountId, displayName) => {
  const data = {
    displayName: displayName,
  };
  return await callLaplacePassportApi(
    `/accounts/${accountId}`,
    LAPLACE_PASSPORT_API_METHOD.PUT,
    data
  );
};

/**
 * アカウントのライセンスを取得する
 * @param {number} accountId - アカウント ID
 * @param {number} page
 * @param {number} limit
 * @param {string} product
 */
export const fetchAccountLicenses = async ({accountId, page = 1, limit = 50, product = ''}) => {
  const productParam = product ? `&product=${product}` : '';
  return await callLaplacePassportApi(
    `/accounts/${accountId}/licenses?page=${page}&limit=${limit}${productParam}`
  );
};

/**
 * ライセンスの割り当てを解除する
 * @param {number} licenseId - ライセンス ID
 */
export const unassignLicense = async (licenseId) => {
  return await callLaplacePassportApi(
    `/licenses/${licenseId}/users`,
    LAPLACE_PASSPORT_API_METHOD.DELETE
  );
};

/**
 * アカウントに所属するユーザを取得する
 * @param {number} accountId - アカウント ID
 */
export const fetchAccountUsers = async (accountId, page = 1, limit = 50) => {
  return await callLaplacePassportApi(`/accounts/${accountId}/users?page=${page}&limit=${limit}`);
};

/**
 * アカウントにユーザを追加する
 * @param {number} accountId - アカウント ID
 * @param {string} mailAddress - 追加するユーザのメールアドレス
 * @param {string} userType - 追加するユーザの権限
 * @returns
 */
export const createAccountUser = async (accountId, mailAddress, userType) => {
  const data = {
    mailAddress: mailAddress,
    type: userType,
  };
  return await callLaplacePassportApi(
    `/accounts/${accountId}/users`,
    LAPLACE_PASSPORT_API_METHOD.POST,
    data
  );
};

/**
 * アカウントに所属するユーザを更新する
 * @param {number} accountId - アカウント ID
 * @param {string} userSub - ユーザの sub
 * @param {Object} data - ユーザの情報
 * @returns
 */
export const updateAccountUser = async (accountId, userSub, data) => {
  return await callLaplacePassportApi(
    `/accounts/${accountId}/users/${userSub}`,
    LAPLACE_PASSPORT_API_METHOD.PUT,
    data
  );
};

/**
 * アカウントからユーザを削除する
 * @param {number} accountId - アカウント ID
 * @param {string} userSub - ユーザの sub
 * @returns
 */
export const deleteAccountUser = async (accountId, userSub) => {
  return await callLaplacePassportApi(
    `/accounts/${accountId}/users/${userSub}`,
    LAPLACE_PASSPORT_API_METHOD.DELETE
  );
};

/**
 * アカウントにユーザとして追加されたことを通知する
 * @param {number} accountId - アカウント ID
 * @param {string} displayName - アカウントの表示名
 * @param {string} mailAddress - 追加されたユーザのメールアドレス
 * @param {string} userType - 追加されたユーザの権限
 * @returns
 */
export const notifyAccountUserAddition = async (accountId, displayName, mailAddress, userType) => {
  const data = {
    accountId: accountId,
    displayName: displayName,
    mailAddress: mailAddress,
    userType: userType,
  };
  return await callLaplacePassportApi('/send-mail', LAPLACE_PASSPORT_API_METHOD.POST, data);
};

/**
 * Solar Pro ダウンロード用の URL を取得する
 */
export const getSolarProDownloadUrl = async (langCode = 'ja') => {
  return await callLaplacePassportApi(
    `/get-solar-pro-installation-url?langCode=${langCode}`,
    LAPLACE_PASSPORT_API_METHOD.GET,
  );
};

/**
 * ユーザ削除に伴う DB のレコードを整理する API を呼び出す
 */
export const cleanUpUserRelations = async () => {
  return await callLaplacePassportApi(
    '/clean-up-user-relations',
    LAPLACE_PASSPORT_API_METHOD.DELETE,
  );
};

export default authCheck;
